import { StyleSheet, Text, View, ActivityIndicator } from 'react-native'
import React, { useEffect, useState } from 'react'
import SelectStore from '../shared/form/SelectStore'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { usePersonalStore } from '../../stores/personalInfo'
import { useLabourStore } from '../../stores/labour'
import { useHomeStore } from '../../stores/home'
import { useTranslation } from 'react-i18next'
import { useInitializeStore } from '../../stores/initialize'
import { mapSelectKey } from '../../utils'

const Showstorebar = ({ navigation }) => {
  const personalstore = usePersonalStore()
  const labourStore = useLabourStore()
  const homeStore = useHomeStore()
  const intializeStore = useInitializeStore()
  const { t } = useTranslation()

  const [stores, setStores] = useState([])
  const [selectedStore, setSelectedStore] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let storeList = []

    const flatten = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        storeList.push(arr[i])
      }
    }

    if (labourStore?.accountDetails?.data) {
      labourStore?.accountDetails?.data.forEach((item) => {
        if (Array.isArray(item?.stores)) {
          flatten(item.stores)
        }
      })
    }

    if (storeList.length > 0) {
      setStores(storeList)
      setLoading(false)
    } else {
      setLoading(false)
    }
  }, [labourStore?.accountDetails?.data])

  // 🔥 Update selectedStore only when both `stores` and `storeNumber` are available
  useEffect(() => {
    if (stores.length > 0 && homeStore?.homeData?.storeNumber) {
      const mappedStore = mapSelectKey(stores, homeStore?.homeData?.storeNumber)

      if (mappedStore) {
        setSelectedStore(mappedStore)
      }
    }
  }, [stores, homeStore?.homeData?.storeNumber])

  if (loading) {
    return <ActivityIndicator size="large" color="#0000ff" />
  }

  return (
    <View
      style={{
        paddingLeft: 16,
        marginTop: -18,
        alignSelf: 'flex-start',
        maxWidth: '100%'
      }}
    >
      {stores.length > 0 && selectedStore && (
        <SelectStore
          title={t('Select Store')}
          options={stores}
          selectedOption={selectedStore}
          onSelect={async (option: string) => {
            console.log(option)

            intializeStore.initialize(option)
            homeStore?.clearData()
            navigation.navigate('Onboarding')
            await AsyncStorage.setItem('storeId', JSON.stringify(option))
          }}
        />
      )}
    </View>
  )
}

export default Showstorebar

const styles = StyleSheet.create({})
